// extracted by mini-css-extract-plugin
module.exports = {"itemTitle":"ServiceAll_itemTitle__1_uhf","categoryLink":"ServiceAll_categoryLink__3T1OH"};